module.exports = __webpack_public_path__ + "img/logo-text-color.9d165ba6.png";